<template>
  <PDVCheckoutForm :order-id="orderId" host="page" />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import PDVCheckoutForm from './PDVCheckoutForm.vue';

const route = useRoute();
const orderId = computed(() => route.params.orderId as string);
</script>
